/**
 * Headless Component
 *
 * Empty component with no presentation logic - returns null.
 * Use this component when you want only business logic and no UI.
 */
export const Headless: React.FC = <TProps,>(_props: TProps): null => {
  // Headless component - no UI
  return null;
};

export default Headless;
